module.exports = __webpack_public_path__ + "media/courses/curricula/images/course-complete-8bef88b1f7a8cc628450aa0f4629efa4.svg";